import { gql } from '@moonpig/web-core-graphql'

export const GetReminderPromptGQL = gql`
  query GetReminderPrompt($remindersRequest: GetRemindersInput!) {
    reminders(input: $remindersRequest) {
      id
      name
      nextDate
      occasion
      relationship
    }
  }
`
